import { Destination } from '../../destination/objects/destination';
import { IataCountry } from '../../iata/objects/iataCountry';
import { Place } from '../../place/objects/place';

export enum SegmentLocationType {
    HOTEL = 'HOTEL',
    AIRPORT = 'AIRPORT',
    STATION = 'STATION',
    PORT = 'PORT',
    CITY_ZONE = 'CITY_ZONE'
}
export interface SegmentLocation {
    id?: number;
    city: null | string;
    code: number;
    country: null | string;
    destination_id: number;
    latitude: number;
    longitude: number;
    name: string;
    type: number;
}

export interface SegmentTransferLocationLocalized {
    id?: number;
    locale: number;
    station?: string;
    port?: string;
}

export interface SegmentTransferLocation {
    linked_hotels: SegmentLocation[],
    linked_airport: null | SegmentLocation,
    linked_station: null | SegmentLocation,
    linked_port: null | SegmentLocation,
    linked_destination: null | SegmentLocation,
    localization: SegmentTransferLocationLocalized[]
}

export type SegmentTransferLocationWithError = { [K in keyof SegmentTransferLocation as `${K}_error`]?: string };

export type SegmentTransferLocationForm = SegmentTransferLocation & SegmentTransferLocationWithError;

export type PlaceForm = Place & { longitude_error?: string; latitude_error?: string };

export interface Segment {
    id: number;
    created_date: Date;
    modified_date: Date;

    origin_name: string;
    going_radius: number,
    origin_dest: Destination;
    origin_location_type: SegmentLocationType;
    origin_geo_location: PlaceForm;
    origin_transfer_location: SegmentTransferLocationForm;

    return_radius: number,
    destination_name: string;
    destination_dest: Destination
    destination_location_type: SegmentLocationType;
    destination_geo_location: PlaceForm;
    destination_transfer_location: SegmentTransferLocationForm;


    country: null | IataCountry;
    town_transfer: boolean;
    duration: number | '';
    distance: number;

    is_round_trip: boolean,
    suppliers: [],
}



export type SegmentFormTypeWithoutError = Omit<Segment, 'id' | 'created_date' | 'modified_date' | 'origin_dest' | 'destination_dest' | 'town_transfer' | 'duration' | 'distance' | 'suppliers'>

export type SegmentFormTypeErrors = {
    [K in keyof SegmentFormTypeWithoutError as `${K}_error`]?: string;
};



export type SegmentFormType = Omit<Segment, 'created_date' | 'modified_date' | 'origin_dest' | 'destination_dest' | 'town_transfer'  | 'distance' | 'suppliers'> & SegmentFormTypeErrors;